import React from "react";
import Typography from "@mui/material/Typography";

const ParaTitle = ({paraTitle}) => {
    return (
        <div>
            <Typography variant="h5" component="div" sx={{ py: '20px' }}>
                {paraTitle}
            </Typography>
        </div>
    );
};

export default ParaTitle;
